module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chart-rents-started-by-type"
  }, [_c('div', {
    staticClass: "thumbnail",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [(!_vm.chartOptions) ? _c('loading') : _c('highcharts', {
    ref: "highcharts",
    attrs: {
      "options": _vm.chartOptions
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1deefdb6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/ChartRentsStartedByType.vue
// module id = 970
// module chunks = 34